import { render } from "./CartCellPrice.vue?vue&type=template&id=2cb243ff"
import script from "./CartCellPrice.vue?vue&type=script&lang=js"
export * from "./CartCellPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__